import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=541c7d0c&"
import script from "./Incident.vue?vue&type=script&lang=js&"
export * from "./Incident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports